import React from 'react';
import DicomdirViewer from './pages/DicomdirViewer';
import GlobalStyle from './styles/globalStyles';

function App() {
  return (
    <>
      <GlobalStyle />
      <DicomdirViewer />
    </>
  );
}

export default App;
